import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3155ROLES } from '../../../U3155';
import type { U3155MinutesWorkNatureFormRow } from '../../../U3155Service';

export type U3155MinutesWorkNatureFormToolbarHandlers = U2000FormStateHandlersReturn<U3155MinutesWorkNatureFormRow> & {
  addNewMinutesWorkNature: () => void;
  modifyMinutesWorkNature: () => void;
  deleteMinutesWorkNature: () => void | Promise<void>;
};

interface U3155MinutesWorkNatureFormToolBarProps {
  formStateHandlers: U3155MinutesWorkNatureFormToolbarHandlers;
}

export const U3155MinutesWorkNatureFormToolBar: React.FC<U3155MinutesWorkNatureFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3155ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewMinutesWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3155ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyMinutesWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3155ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteMinutesWorkNature();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
